import { UserProps } from "./user.type"

export interface OrderManagmentPurchaseOrderItemsResponseLinks {
  quantity: number,
  reference: string,
  availableQuantity: number,
  cost: number,
  total: number,
  currency: "MXN" | "USD"
  buyerCompanyName?: string,
  category?: string,
}

export interface OrderManagmentPurchaseOrderItemsResponse {
  name: string,
  uuid: string,
  links?: OrderManagmentPurchaseOrderItemsResponseLinks[],
}

export enum SupplyOrderCommentTypesEnum {
  'default' = 'default',
}
export interface SupplyOrderCommentsProps {
  type: SupplyOrderCommentTypesEnum
  subject?: string
  comment: string
  user: UserProps
  createdAt: string
  updatedAt?: string
  uuid?: string
}

export interface SupplyOrderCommentsWithPagesProps {
  count: number
  next?: string
  previous?: string
  results?: SupplyOrderCommentsProps[]
}